import type { WebsiteContent } from './types'

export const footer: WebsiteContent['footer'] = {
  title: "Ready to work on what's NXT?",
  subtitle: "Let's find solutions together and bring your ideas to life.",
  privacyLabel: 'Privacy Policy',
  copyright: '© 2026 NXT Humans',
}
